import React from 'react'
import { Link } from 'react-router-dom';

import '../../styles/invest.css'
import { GoVerified } from "react-icons/go";
import IMGS from '../../../investment/assets'
const Invest = () => {
  return (
    <>
      <div className="investment">
        <h2>Investment Management</h2>
        <h4>Setting yourself up for the future</h4>
        <div className="inv-int">
          <div className="inv-img" style={{ "backgroundImage": `url(${IMGS.phone})` }}></div>
          <p>You could certainly take a DIY approach to investing, but imagine what you could do with a financial professional in your corner.
            Especially someone who takes the time to get to know you before making recommendations.
            The financial consultants at Flagstar Wealth Services can provide a financial roadmap for your specific goals, like retirement or education, or for building your overall wealth.
          </p>
        </div>
        <div className="inv-more">
          <div className="left">
            <h3>Working with our Financial Consultants</h3>
            <p>Investment decisions can be complex, but you can rely on our expertise and experience to guide you.
              After looking at the complete picture of your finances, we develop strategies customized for you to meet your specific milestones.
              And, like all good partners, we stay in touch, so we can adjust your portfolio as needed based on performance, life events, or new priorities.
            </p>
          </div>
          <div className="right">
            <ul>
              <li><GoVerified /> <p>Wide range of investment offerings</p></li>
              <li><GoVerified /> <p>401(k) transition assistance</p></li>
              <li><GoVerified /> <p>Roth IRA conversions</p></li>
              <li><GoVerified /> <p>Asset allocation</p></li>
              <li><GoVerified /> <p>Performance monitoring and asset allocation </p></li>
              <li><GoVerified /> <p>Investment strategies based on your objectives and risk tolerance</p></li>
              <li><GoVerified /> <p>Asset preservation and tax-advantaged strategies</p></li>
            </ul>
          </div>
          <div className="bttm">
            <Link to={`/investments`}>Learn more</Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default Invest